// extracted by mini-css-extract-plugin
export default {"acknowledgement":"Main_acknowledgement__2cvy8"};